import React, { FC } from 'react';

import type { RootMenuItem as RootMenuItemType } from '../../../../BettingMenu/types';

import { Icon, IconSize } from 'app/design-system/components/Icon';
import { useTranslation } from 'app/lang';
import { getDictionaryDataItems } from 'app/modules/Navigation/utils';
import { getServiceIconName } from 'app/modules/ServiceMenu/utils';

import styles from '../../RootMenu.module.scss';

type LinkContentProps = {
  entry: RootMenuItemType;
};

export const LinkContent: FC<LinkContentProps> = ({
  entry,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Icon icon={getServiceIconName(entry.key)}
            size={IconSize.DEFAULT}
            className={styles.icon} />
      <span className={styles.label}
            data-test="item-label">
        {getDictionaryDataItems(t, entry.label)}
      </span>
    </>
  );
};
